import { render, staticRenderFns } from "./ButtonDownload.vue?vue&type=template&id=dfd7385a&scoped=true&"
import script from "./ButtonDownload.vue?vue&type=script&lang=js&"
export * from "./ButtonDownload.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDownload.vue?vue&type=style&index=0&id=dfd7385a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd7385a",
  null
  
)

export default component.exports